module.exports = {
  convertCase: (str) => String(str).toLowerCase().replace(/(^| )(\w)/g, x => x.toUpperCase())
}



// WEBPACK FOOTER //
// ./src/utils/Strings.js